const PARENT_ORIGIN = process.env.VUE_APP_PARENT_ORIGIN

export const isEmbedded = window.parent !== window

export function openInParent (path) {
  if (isEmbedded && PARENT_ORIGIN) {
    window.open(PARENT_ORIGIN + path, '_blank')
  } else {
    window.open(path, '_blank')
  }
}

export function notifyParent (type, url) {
  if (isEmbedded && PARENT_ORIGIN) {
    window.parent.postMessage({ type, url, }, PARENT_ORIGIN)
  }
}
